export const STORE_STAGING_IDS = {
  TDOT: 'b475b552-cae4-45b2-a6c9-b913d0ed538f',
  EASY_BATHROOMS: '53274b5c-4dd4-42b6-8d5b-98e9e5bfdad3',
};

export const STORE_PROD_IDS = {
  TDOT: 'a1e32fb4-9394-4bcb-8d36-d0716b3e8858',
  EASY_BATHROOMS: '5d7639a6-667a-491e-a906-eed6eab604ab',
};

export const isTDOT = (storeId?: string) =>
  storeId && [STORE_PROD_IDS.TDOT, STORE_STAGING_IDS.TDOT].includes(storeId);

export const isEasyBathrooms = (storeId?: string) =>
  storeId &&
  [STORE_PROD_IDS.EASY_BATHROOMS, STORE_STAGING_IDS.EASY_BATHROOMS].includes(
    storeId
  );

export const SUPERBAR_ROOT_SELECTOR = '#caddie-root';
